export default function sortByPositionKey (arr: any[], key: string = 'position'): any[] {
  return arr.slice().sort((a: any, b: any) => {
    return a[key] - b[key]
  })
}
